import getFirstCharacter from './getFirstCharacter'
import emojiRegex from 'emoji-regex'

export default function stripLeadingEmojiFromText (string: string) {
  const firstCharacter = getFirstCharacter(string)
  if (firstCharacter === undefined || !emojiRegex().test(firstCharacter)) return string
  return string.substring(firstCharacter.length)
}
